import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { orgName } from '../../selectors/organization';
import { RootDispatch, RootState } from '../../store';
import OrgHeader from '../OrgHeader';
import getApiEnv from '../../services/sdkConnector/ApiEnv';

import styles from './RequestAccess.module.css';

function RequestAccessComponent({ requestAccess }: { requestAccess: Function }) {
  const isIhis = /(ihis)/.test(getApiEnv());
  return (
    <div className={styles.container}>
      <OrgHeader className={styles.orgHeader} />
      <div className={styles.body}>
        <div className={styles.header}>
          <FormattedMessage id={'requestAccessPage.greeting'} />
        </div>
        <div className={styles.copy}>
          <FormattedMessage id={'requestAccessPage.details'} />
        </div>
        <button
          className={styles.requestButton}
          aria-label="request-access"
          onClick={() => {
            requestAccess();
          }}
        >
          <FormattedMessage id={'requestAccessPage.requestButton'} />
        </button>
      </div>
      <div className={styles.footer}>
        <FormattedMessage id={`requestAccessPage.footer${isIhis ? 'Ihis' : ''}`} />
      </div>
    </div>
  );
}

const mapState = (state: RootState) => ({
  organization: orgName(state),
});

const mapDispatch = ({ currentPage: { requestAccess } }: RootDispatch) => ({
  requestAccess,
});

// https://tigertext.atlassian.net/browse/TMG-837
// @ts-expect-error
export const RequestAccess = connect(mapState, mapDispatch)(RequestAccessComponent);

export default RequestAccess;
